"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
const v1_1 = require("../../v1");
const v1 = v1_1.Types.Api.Types;
class Types {
    static AgreementsSchema;
    static GeneralSchema;
    static NodeSchema;
    static CardSchema;
    static ContactSchema;
    static ProfileSchema;
    static SecuritySchema;
    static StateSchema;
    static UserSchema;
    static AppSchema;
    static PreferenceSchema;
    static VaultSchema;
    static MountedUserSchema;
    static SecurityTypes;
    static SecurityLevel;
    static Blank;
}
exports.Types = Types;
//# sourceMappingURL=index.js.map